export const getFormattedDate = () => {
    const currentDate = new Date();
    return `${currentDate.getMonth()+1}/${currentDate.getDate()}/${currentDate.getFullYear()}`
}

const getZeroPaddedDatePart = (datePart) => {
  if (datePart < 10) {
    return `0${datePart}`
  }
  return datePart
}

export const getFormattedDateYYYMMDD = (date)  => {
    const dateFull = new Date(date);
    return `${dateFull.getFullYear()}/${getZeroPaddedDatePart(dateFull.getMonth() + 1)}/${getZeroPaddedDatePart(dateFull.getDate())}`;
}

export const getMoFormDataTransformed = (moneyOrderEl, currentDateEl) => {
  const moFormEl = moneyOrderEl.querySelector("#mo-form");
  const formdata = new FormData(moFormEl);
  currentDateEl.innerHTML = getFormattedDate();

  let dataMo = [];
  for (let [key, value] of formdata.entries()) {
    let keySplit = key.split("-");
    let count = keySplit.pop();
    if (isNaN(count)) {
      keySplit.push(count);
      count = 0;
    }
    dataMo[count] = {
      ...dataMo[count],
      ...{
        [keySplit.join("-")]: value,
      },
    };
  }
  dataMo = dataMo.filter((z) => z);
  return dataMo;
};
